import type { KeyboardEvent } from 'react'

export function preventSubmitOnEnter(event: KeyboardEvent<HTMLInputElement>) {
  if (event.key === 'Enter') event.preventDefault()
}
